import { m, useCycle } from 'framer-motion';
import { type ComponentType, useRef } from 'react';

import { MenuToggle } from './MenuToggle';
import { Navigation } from './Navigation';
import styles from './styles.module.css';
import { useDimensions } from './use-dimensions';

import type { NavConfig } from '../../../../routes';
import type { FC } from 'react';

const myHeight = 100;
const heightMultiplier = 2;

const sidebar = {
  open: {
    clipPath: `circle(${myHeight * heightMultiplier}% at 100% 0%)`,
    transition: {
      type: 'spring',
      stiffness: 20,
      restDelta: 2
    }
  },
  closed: {
    clipPath: 'circle(0% at 100% 0%)',
    transition: {
      type: 'spring',
      stiffness: 400,
      damping: 40
    }
  }
};

export const MobileNav: FC<{navConfig: NavConfig; label: ComponentType}> = ( { navConfig } ) => {

  const [ isOpen, toggleOpen ] = useCycle(false, true);
  const containerRef = useRef(null);
  const { height } = useDimensions(containerRef);

  return (
    <m.nav
      className={styles.testing}
      initial={false}
      animate={isOpen ? 'open' : 'closed'}
      custom={height}
      ref={containerRef}
    >
      <m.div className={styles.background} variants={sidebar}/>
      <Navigation navConfig={navConfig}/>
      <MenuToggle toggle={() => toggleOpen()}/>
    </m.nav>
  );
};
